import React, { useEffect } from 'react';

import { parseUrlParams } from 'utils/parseUrlParams';

const WorkflowComplete = () => {
  useEffect(() => {
    const params = parseUrlParams(window.location.search);
    window.top.postMessage(
      {
        error: false,
        docuSignComplete: true,
        ...params,
      },
      '*'
    );
  }, []);

  return (
    <div>
      <h3>Docusign complete</h3>
    </div>
  );
};

export default WorkflowComplete;
